import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog as MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-log-detail',
  templateUrl: './log-detail.component.html',
  styleUrls: ['./log-detail.component.css', '../../../app.component.css']
})
export class LogDetailComponent implements OnInit {
  formulario: FormGroup;
  titulo: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder) { }

  async ngOnInit(): Promise<void> {
    this.formulario = this.formBuilder.group({
      data: [null],
      usuario: [null],
      descricao: [null]
    });

    let usuario = this.data?.usuario;
    if (typeof usuario === 'object' && usuario !== null) {
      usuario = usuario.nome;
    }

    this.formulario.patchValue({
      data: this.datePipe.transform(this.data?.data, 'dd/MM/yyyy HH:mm:ss'),
      usuario: usuario,
      descricao: this.data?.descricao
    });
    this.formulario.markAsPristine();
    this.titulo = this.data.titulo === null || this.data.titulo === undefined ? `Log nº ${this.data?.id}` : this.data.titulo;
  }

  cancelClick(): string {
    this.dialog.closeAll();
    return 'cancel';
  }
}
